import React, { useState, useEffect } from 'react';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import format from 'date-fns/format';
import { makeStyles, fade } from '@material-ui/core/styles';
import { notificationCenterWidth, RightSideBarWidth } from '../../../styleVariables';
import useMountEffect from '../../../mountEffect';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import * as logger from "../../../logger";
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import { connect } from 'react-redux';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import {
  updateChatView, toggleChatSupport, onlinePaymentsConfig
} from "../../../store/actions/userActionCreators";
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import { freshChat } from '../../../configs/configs';
import FreshChat from 'react-freshchat';
import MobileStepper from '@material-ui/core/MobileStepper';
import { DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { biltyContinueClick } from '../../../store/actions/tripActionCreator';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ExcelIcon, PdfIconWhite } from '../../../components/icons';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { getDriverLedgerV2, getShopKhataData } from '../../../store/actions/homeActionCreator';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { numberFormat, numberWithCommas, validNumberCheck, replaceCommas, findArrayObject } from '../../../utils/utils';
import { RightArrow } from '../TopCard/icons';
import Highlighter from "react-highlight-words";
import { Form } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import AmountInput from '../Inputs/AmountInput';
import { InputAdornment } from '@material-ui/core';
import TextInputState from '../Inputs/TextInputState';
import { getBankDetails, getPaymentLink,getPaymentInitiate } from '../../../store/actions/OnlinePaymentActionCreators';
import AddIcon from '@material-ui/icons/Add';
import AddBankDetailsDialog from '../Bank/AddBankDetailsDialog';
import SuccessDialog from '../Verfication/SuccessDialog';
import FailureDialog from '../Verfication/FailureDialog';
import BankDetailsSelectionDialog from '../Bank/BankDetailsSelectionDialog';
import { VerifiedBankAccount, UnVerifiedBankAccount } from '../TopCard/icons';
import { trackDwebEvent } from '../../analytics';
import AddPhoneNumberDialog from '../Dialog/AddPhoneNumberDialog';
import { getUserDetails } from '../../../store/actions/authActionCreators';
import AddShop from '../../pages/Shops/AddShop';
import DwebPaymentGateWayDialog from '../Dialog/DwebPaymentGateWayDialog';
const useStyles = makeStyles(theme => ({
  transactionDetailsDrawer: {
    width: 538,
    maxWidth: 538,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  modal: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  backdrop: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    }
  },
  container: {
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    zIndex: 1,
    flexGrow: 1
  },
  sideBarDialogContentV1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 20,
    backgroundColor: '#f6f6f8'
  },
  divTitle: {
    display: 'flex',
    alignItems: 'center',
    color: "#0b1323",
    fontSize: 18,
    marginBottom: 4
  },
  divSecTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    color: "rgba(11, 19, 35, 0.75);",
    marginBottom: 8
  },
  titleDiv: {
    display: 'flex',
    flexDirection: 'column'
  },
  search: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#fff",
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    border: "solid 1px rgba(11, 19, 35, 0.5)",
    marginRight: 0,
    marginLeft: 0,
    width: '100%',
  },
  sicon: {
    fontSize: 18
  },
  searchIcon: {
    padding: "0px 12px",
    height: '100%',
    color: "rgba(11, 19, 35, 0.75)",
    //position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    padding: "0px 12px",
    height: '100%',
    color: "rgba(11, 19, 35, 0.75)",
    //position: 'absolute',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    fontSize: 14,
    padding: "9px 0px",
    //paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    width: '100%'
  },
  sideBarActions: {
    paddingTop: 24,
    paddingBottom: '24px !important',
    paddingRight: 30,
    paddingLeft: 30,
    backgroundColor: 'white'
  },
  subTitleSec: {
    marginBottom: 8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  bankSubTitleSec: {
    marginBottom: 2,
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:last-child': {
      marginBottom: 0
    }
  },
  listingDiv: {
    marginTop: 24
  },
  subTitleTxt: {
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(11, 19, 35, 0.5)"
  },
  driverDiv: {
    padding: 16,
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    //transition:'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    marginBottom: 12,
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'cente',
    justifyContent: 'space-between'
  },
  nameDiv: {
    display: 'flex',
    flexDirection: 'column',
    //alignItems:'center',
    fontSize: 16
  },
  bankValueDiv: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 16
  },
  balanceDiv: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16
  },
  listDriverBalance: {
    fontWeight: 600
  },
  listDriverBalancePositive: {
    fontWeight: 600,
    color: "#379953"
  },
  listDriverBalanceZero: {
    fontWeight: 600,
    color: "#0b1323"
  },
  listDriverBalanceNegative: {
    fontWeight: 600,
    color: "#ff0000"
  },
  highlight: {
    color: "#1860f0",
    padding: 0
  },
  driverDetailsDiv: {
    padding: "16px 24px",
    borderRadius: 8,
    border: "solid 1px #dcdcdc",
    backgroundColor: " #ededed",
    marginBottom: 24,
    marginTop: 2
  },
  bankDetailsDiv: {
    padding: 16,
    borderRadius: 8,
    backgroundColor: " #fff",
    marginBottom: 24,
    marginTop: 2
  },
  infoDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  titleV2: {
    fontSize: 14,
    fontWeight: 600,
    color: '#6b778c',
    marginBottom: 4
  },
  newInput: {
    backgroundColor: '#fff',
    paddingLeft: 16,
    border: "solid 1px #dedede",
    "& .MuiInputBase-input": {
      paddingTop: 12,
      paddingBottom: 12,
      paddingLeft: 0
    }
  },
  changeButton: {
    padding: "8px 16px",
    borderRadius: 8,
    border: "solid 1px #f1f1f1",
    backgroundColor: " #0033cc",
    fontSize: 12,
    fontWeight: 600,
    color: "#fff",
    "&:hover": {
      backgroundColor: " #0033cc",
    }
  },
  addBankDetailsButton: {
    padding: "12px 16px 12px 12px",
    borderRadius: 4,
    border: "solid 1px #0033cc",
    backgroundColor: "#0033cc",
    fontSize: 16,
    fontWeight: 600,
    color: "#fff",
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: "#0033cc",
    }
  },
  verifiedAccount: {
    fontSize: 12,
    color: "rgba(21, 128, 38, 0.6)"
  },
  unVerifiedAccount: {
    fontSize: 12,
    color: "#e93333"
  },
  valueTxt: {
    textTransform: 'capitalize',
    fontWeight: 600
  },
  valueTxt1: {
    textTransform: 'capitalize',
  },
  alignEnd: {
    textAlign: 'end'
  },
  payNowButton: {
    marginLeft: 16,
    padding: '6px 30px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#09101e',
    fontSize: 14,
    fontWeight: 600,
    color: '#fff',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: "#09101e",
    }
  },
  balance: {
    color: "rgba(11, 19, 35, 0.75)",
    fontSize: 12,
    paddingLeft: 8,
    textTransform: 'uppercase'
  },
  driverName: {
    fontSize: 12
  },
  emptyStateDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  emptyTxt: {
    color: "#787878",
    marginTop: 32,
    textAlign: 'center'
  },
  addCta: {
    backgroundColor: "#0033cc",
    textTransform: "uppercase",
    fontWeight: 600,
    color: '#fff',
    paddingTop: 17,
    paddingBottom: 17,
    borderRadius: 8,
    width: '100%',
    '&:hover': {
      backgroundColor: "#0033cc",
    }
  }
}));

const PayShopSideBar = ({
  rightSideBarOpen,
  toggleRightSideBar,
  user,
  defaultData,
  children,
  sideBarName,
  sideBarTitle,
  sideBarSecondaryTitle,
  handleSubmit,
  fromSingleShop,
  dispatchChatView,
  dispatchFetchAllDrivers,
  dispatchFetchBankDetails,
  dispatchGetPaymentLink,
  dispatchGetUserDetails,
  dispatchGetOnlinePaymentsConfig,
  dispatchGetShopsDataAction,
  dispatchGetPaymentInitiate
}) => {
  let submit, formValues;
  const classes = useStyles();
  const [updateChatView, setChatView] = useState(false);
  const [progress, setProgress] = useState(25);
  const [successCreation, setSuccessCreation] = useState(false);
  const [failureCreation, setFailureCreation] = useState(false);
  const [shopSearchTxt, setShopSearchTxt] = useState("");
  const [selectedShop, setSelectedShop] = useState(null);
  /**Drivers Data Fetching */
  const [shopLedgerData, setDriverLedgerData] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [addBankDetails, setAddBankDetails] = useState(false)
  const [selectBank, setSelectBank] = useState(false)
  const [amount, setAmount] = useState(null);
  const [reason, setReason] = useState(null);
  const [addPhoneNumber, setAddPhoneNumber] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [configInfo, setConfigInfo] = useState({});
  const [addShopOpen, setAddShopOpen] = useState(false);
  const [recall, setRecall] = useState(false);

  //Payment GateWay
  const [customPGOpen, setCustomPGOpen] = useState(false);
  const [cashFreeOrderData,setCashFreeOrderData] = useState(null);
  const [orderRequestData,setOrderRequestData] = useState(null);



  const driverLedgerRequestData = {
    fleetOwnerId: user.userInfo.entityId,
    // pageNo: 1,
    // pageSize: 10,
  };

  useEffect(() => {

    if (user && user.onlinePaymentConfig) {
      setConfigInfo(user.onlinePaymentConfig);
    } else {
      setConfigInfo({});
    }

  }, [user.onlinePaymentConfig]);

  useEffect(() => {

    if (user && user.userInfoProfile) {
      setUserInfo(user.userInfoProfile);
    }

  }, [user.userInfoProfile]);
  const handleAddShopClick = () => {
    setAddShopOpen(true);
  }
  const handleAddShopModalClose = (status) => {
    setAddShopOpen(false);
  }
  const handleShopSave = (status) => {
    setAddShopOpen(false);
    setRecall(!recall)
  }
  useEffect(() => dispatchGetShopsDataAction(null,
    () => {
      logger.log("Shops dWeb", "Fetch all shop successfull");
      trackDwebEvent('Dweb Online Payments Shops listing page', {});
    },
    () => {
      logger.log("shops dWeb", "Fetch all shops failed");
    }
  ), [dispatchGetShopsDataAction, recall]);

  useEffect(() => {
    if (user.shopsData) {
      setDriverLedgerData(user.shopsData);
      if (defaultData && defaultData.entityType && defaultData.entityId) {
        let shop = findArrayObject("id", defaultData.entityId, user.shopsData);
        if (shop && shop.id) {
          setAmount(defaultData.amount ? defaultData.amount : null)
          handleShopSelect(shop)
        }
      }
    }
  }, [user.shopsData]);
  /**Drivers Data Fetching */


  useEffect(() => {
    dispatchChatView(false);
  }, []);

  const loadBanKList = () => {
    if (selectedShop && selectedShop.id) {
      let reqData = {
        type: "KHATA_SHOP",
        id: selectedShop.id
      }
      dispatchFetchBankDetails(reqData, (response) => {
        if (response && response.status && response.status.code == 200 && response.response && response.response.length > 0) {
          setBankList(response.response)
        }
      }, () => {

      })
    }
  }

  const handleClose = (fromResponse) => {


    dispatchChatView(true);

    let finalBank = bankList.filter(v => v && v.is_default);

    const entityData = {
      shopId: selectedShop && selectedShop.id ? selectedShop.id : "",
      name: selectedShop && selectedShop.name ? selectedShop.name : "",
      balance: selectedShop && selectedShop.balance ? selectedShop.balance : "",
      amount: amount ? amount : "",
      reason: reason ? reason : "",
      bankAccountId: finalBank && finalBank[0] && finalBank[0].id ? finalBank[0].id : ""
    }

    if (selectedShop && !fromResponse) {
      trackDwebEvent('Dweb Shop payout form page cancelled', {
        shop_id: selectedShop && selectedShop.id ? selectedShop.id : "",
        shop_name: selectedShop && selectedShop.name ? selectedShop.name : "",
        balance: selectedShop && selectedShop.balance ? selectedShop.balance : "",
        shop_payout_amount: amount ? amount : "",
        shop_payout_reason: reason ? reason : "",
        bank_account_id: finalBank && finalBank[0] && finalBank[0].id ? finalBank[0].id : ""
      });

    }

    if (toggleRightSideBar) {
      toggleRightSideBar(entityData)
    }
  }
  const handleAddBankClose = () => {
    setAddBankDetails(false)
  }
  const handleAddBankSave = (status) => {
    if (status) {
      handleSuccessOpen()
      setTimeout(() => {
        handleSuccessClose()
      }, 3000);
    } else {
      handleFailureOpen()
      setTimeout(() => {
        handleFailureClose()
      }, 3000);
    }
    loadBanKList()
    setAddBankDetails(false)
  }
  const handleAddBankOpen = () => {
    setAddBankDetails(true);
    trackDwebEvent('Dweb Shop payout add bank account initiated', {
      shop_name: selectedShop && selectedShop.name ? selectedShop.name : "",
      shop_id: selectedShop && selectedShop.id ? selectedShop.id : "",
      contact_number: selectedShop && selectedShop.contactNumber ? selectedShop.contactNumber : "",
      shop_balance: selectedShop && selectedShop.balance ? selectedShop.balance : ""
    });
  }
  //Select Bank
  const handleSelectBankOpen = () => {
    setSelectBank(true)
  }
  const handleSelectBankClose = () => {
    setSelectBank(false)
  }
  const handleSelectBankSave = (status) => {
    if (status) {
      loadBanKList()
    }
    setSelectBank(false)
  }

  const handleCustomPGClose = () => {
    setCustomPGOpen(false);
    setOrderRequestData(null);
    setCashFreeOrderData(null);
    //handleClose(true)
  }
  const handleCustomPGConfirm = () => {
    setCustomPGOpen(false);
    setOrderRequestData(null);
    setCashFreeOrderData(null);
    handleClose(true)
  }
  
  const handleSuccessOpen = () => {
    setSuccessCreation(true)
  }
  const handleSuccessClose = () => {
    setSuccessCreation(false)
  }
  const handleFailureOpen = () => {
    setFailureCreation(true)
  }
  const handleFailureClose = () => {
    setFailureCreation(false)
  }
  const handleSave = () => {
    if (handleSubmit) {
      handleSubmit()
    }
    //dispatchChatView(true);
  }
  const handleShopSelect = (shop) => {
    if (shop && shop.id) {
      trackDwebEvent('Dweb Online Payments shop selected', {
        shop_name: shop && shop.name ? shop.name : "",
        shop_id: shop && shop.id ? shop.id : "",
        contact_number: shop && shop.contactNumber ? shop.contactNumber : "",
        shop_balance: shop && shop.balance ? shop.balance : ""
      });
      let reqData = {
        type: "KHATA_SHOP",
        id: shop.id
      }


      dispatchGetUserDetails(
        (data) => {
          if (data && data.status && data.status.code == 200) {
            logger.log('Pay Driver Side Bar Dweb', 'Fetch User Details Successfull');
            dispatchGetOnlinePaymentsConfig(
              (data) => {
                if (data && data.status && data.status.code == 200) {
                  logger.log('Pay Shop Side Bar Dweb', 'Get Online Payments Config Successfull');
                  dispatchFetchBankDetails(reqData, (response) => {
                    if (response && response.status && response.status.code == 200 && response.response && response.response.length > 0) {
                      trackDwebEvent('Dweb shop payout form page', {
                        shop_name: shop && shop.name ? shop.name : "",
                        shop_id: shop && shop.id ? shop.id : "",
                        contact_number: shop && shop.contactNumber ? shop.contactNumber : "",
                        shop_balance: shop && shop.balance ? shop.balance : ""
                      });
                      setBankList(response.response);
                    }
                    setSelectedShop(shop);
                  }, () => {

                  })
                }
              },
              () => {
                logger.log('Pay Shop Side Bar Dweb', 'Get Online Payments Config Failed');
              }
            );
          }
        },
        () => {
          logger.log('Pay Shop Side Bar Dweb', 'Fetch User Details Failed');
        }
      );
    }
  }
  const validate = values => {

    const errors = {};
    let transactionLimit = 0;

    if (!values.amount) {
      errors.amount = 'Amount Required';
    }
    if (!values.reason) {
      errors.reason = 'Reason Required';
    }
    if (values.amount && !validNumberCheck(values.amount)) {
      errors.amount = 'Invalid Amount';
    }

    if (userInfo) {
      if (!userInfo.isKYCVerified && !userInfo.isPaymentsWhitelisted) {
        transactionLimit = configInfo && configInfo.transactionLimit ? configInfo.transactionLimit : 0;
      } else if (userInfo.isPaymentsWhitelisted && !userInfo.isKYCVerified) {
        transactionLimit = configInfo && configInfo.whiteListedUserTransactionLimit ? configInfo.whiteListedUserTransactionLimit : 0;
      } else if (userInfo.isKYCVerified) {
        transactionLimit = configInfo && configInfo.KycUserTransactionLimit ? configInfo.KycUserTransactionLimit : 0;
      }
    }


    /*if (values.amount && validNumberCheck(values.amount) && Number(replaceCommas(values.amount)) > Number(transactionLimit)) {
      errors.amount = 'Amount cannot be greater than ' + numberFormat(transactionLimit);
    }*/


    return errors;
  };

  let initialValues = {
    amount: amount,
    reason: reason
  };

  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);

    if (selectedShop && selectedShop.contactNumber) {
      handlePayNow(values);
    } else {
      setAddPhoneNumber(true);
    }

  };

  const addPhoneNumberDialogClose = () => {
    setAddPhoneNumber(false);
  }

  const addPhoneNumberDialogConfirm = () => {
    setAddPhoneNumber(false);
    handlePayNow();
  }

  const handlePayNow = () => {
    let finalBank = bankList.filter(v => v && v.is_default);
    if (finalBank && finalBank.length > 0 && finalBank[0] && finalBank[0].id) {
      let reqData = {
        "bankId": `${finalBank[0].id}`,
        "payerType": "USER",
        "payeeType": "KHATA_SHOP",
        "payments": [
          {
            "amount": Number(replaceCommas(amount))
          }
        ],
        "payerId": user.userInfo.entityId,
        "description": reason,
        "payeeId": `${selectedShop && selectedShop.id ? selectedShop.id : ""}`,
        "paymentView": "web_v2",
        "returnUrl": `${window.location.href}`
      }
      dispatchGetPaymentInitiate(reqData, (data) => {
        if (data && data.status && data.status.code == 200 && data.response) {
            setOrderRequestData({
              ...reqData,
              orderAmount: Number(replaceCommas(amount)),
              selectedShop:selectedShop,
              finalBank:finalBank[0],
              returnUrl: `${window.location.href}`
            });
            setCashFreeOrderData(data.response);
            setCustomPGOpen(true)
            //handleClose(true)
        }else{
          handleClose(true)
        }
        /*if (data && data.status && data.status.code == 200 && data.response && data.response.paymentLink) {
          trackDwebEvent('Dweb Shop payout form page successful', {
            shop_id: selectedShop && selectedShop.id ? selectedShop.id : "",
            shop_name: selectedShop && selectedShop.name ? selectedShop.name : "",
            shop_balance: selectedShop && selectedShop.balance ? selectedShop.balance : "",
            shop_payout_amount: amount ? amount : "",
            shop_payout_reason: reason ? reason : "",
            bank_account_id: finalBank[0].id
          });
          window.location.href = data.response.paymentLink;
        } else {
          trackDwebEvent('Dweb Shop payout form page failed', {
            shop_id: selectedShop && selectedShop.id ? selectedShop.id : "",
            shop_name: selectedShop && selectedShop.name ? selectedShop.name : "",
            shop_balance: selectedShop && selectedShop.balance ? selectedShop.balance : "",
            shop_payout_amount: amount ? amount : "",
            shop_payout_reason: reason ? reason : "",
            bank_account_id: finalBank[0].id,
            error_reason: data && data.status && data.status.message ? data.status.message : ""
          });
        }*/
      }, (data) => {
        trackDwebEvent('Dweb Shop payout form page failed', {
          shop_id: selectedShop && selectedShop.id ? selectedShop.id : "",
          shop_name: selectedShop && selectedShop.name ? selectedShop.name : "",
          shop_balance: selectedShop && selectedShop.balance ? selectedShop.balance : "",
          shop_payout_amount: amount ? amount : "",
          shop_payout_reason: reason ? reason : "",
          bank_account_id: finalBank[0].id,
          error_reason: data && data.status && data.status.message ? data.status.message : ""
        });
        handleClose(true)
      })
    }
  }

  const getFormFields = (values) => {
    return [
      {
        size: 12,
        visible: true,
        inline: false,
        field: (
          <>
            <div className={classes.titleV2}>Amount to Send*</div>
            <AmountInput
              // label="Truck Hire Cost"
              placeholder="Enter a amount"
              name="amount"
              margin="none"
              fullWidth={true}
              variant="outlined"
              size="small"
              onChange={(e) => {
                setAmount(e.target.value)
              }}
              fieldProps={{
                parse: value => value && numberWithCommas(value)
              }}
              InputProps={{
                className: classes.newInput,
                startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
              }}
              required={true}
            />
          </>
        ),
      },
      {
        size: 12,
        visible: true,
        inline: false,
        field: (
          <>
            <div className={classes.titleV2}>Reason for Sending Money*</div>
            <TextInputState
              // label="Truck Hire Cost"
              placeholder="Enter a reason"
              name="reason"
              margin="none"
              fullWidth={true}
              variant="outlined"
              size="small"
              onChange={(e) => {
                setReason(e.target.value)
              }}
              InputProps={{
                className: classes.newInput,
              }}
              required={true}
            />
          </>
        ),
      },
      {
        size: 12,
        visible: bankList && bankList.length == 0,
        field: (
          <>
            <Button className={classes.addBankDetailsButton} variant='outlined' onClick={() => handleAddBankOpen()}>
              <AddIcon /> Add Shops’s Bank Account
            </Button>
          </>
        ),
      },
      {
        size: 12,
        visible: bankList && bankList.length > 0,
        field: (
          <>
            <div className={classes.titleV2}>Account Details</div>
            {bankList && bankList && bankList.length > 0 && bankList.filter(v => v && v.is_default).map((bank) => {
              return (
                <div className={classes.bankDetailsDiv}>
                  {bank && bank.acc_type && bank.acc_type == 'BANK'&&<><Grid container spacing={2}>
                  <Grid item xs={4}>
                      <div className={classes.bankValueDiv}>
                        <Typography className={classes.subTitleTxt}>Name</Typography>
                        <Typography className={classes.valueTxt}>
                          {bank && bank.acc_holder_name ? bank.acc_holder_name.toLowerCase() : ""}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div className={classes.bankValueDiv}>
                        <Typography className={classes.subTitleTxt}>Account Number</Typography>
                        <Typography className={classes.valueTxt}>{bank && bank.acc_number ? bank.acc_number : ""}</Typography>
                      </div>
                    </Grid>
                    <Grid item xs={4} className={classes.alignEnd}>
                      {bank && bank.broker_verification_status && <><VerifiedBankAccount />
                        <Typography className={classes.verifiedAccount}>Verified Account</Typography></>}
                      {bank && !bank.broker_verification_status && <><UnVerifiedBankAccount />
                        <Typography className={classes.unVerifiedAccount}>Verification Failed</Typography></>}
                    </Grid>
                    <Grid item xs={4}>
                      <div className={classes.bankValueDiv}>
                        <Typography className={classes.subTitleTxt}>Bank Name</Typography>
                        <Typography className={classes.valueTxt1}>
                          {bank && bank.bank_name ? bank.bank_name.toLowerCase() : ""}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div className={classes.bankValueDiv}>
                        <Typography className={classes.subTitleTxt}>IFSC Code</Typography>
                        <Typography className={classes.valueTxt1}>{bank && bank.ifsc_code ? bank.ifsc_code : ""}</Typography>
                      </div>
                    </Grid>
                    <Grid item xs={4} className={classes.alignEnd} >
                      <Button className={classes.changeButton} variant='outlined' onClick={() => handleSelectBankOpen()}>
                        Change
                      </Button>
                    </Grid> 
                  </Grid></>}
                  {bank && bank.acc_type && bank.acc_type == 'UPI'&&<>
                      <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <div className={classes.bankValueDiv}>
                              <Typography className={classes.subTitleTxt}>UPI ID</Typography>
                              <Typography className={classes.valueTxtUPI}>
                                  {bank && bank.upi_address ? bank.upi_address : ""}
                              </Typography>
                          </div>
                          <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                            {bank && bank.broker_verification_status && <><VerifiedBankAccount />
                                &nbsp;
                                <Typography className={classes.verifiedAccount}>Verified Account</Typography></>}
                            {bank && !bank.broker_verification_status && <><UnVerifiedBankAccount />
                                &nbsp;
                                <Typography className={classes.unVerifiedAccount}>Verification Failed</Typography></>}
                                &nbsp;&nbsp;
                            <Button className={classes.changeButton} variant='outlined' onClick={() => handleSelectBankOpen()}>
                                Change
                            </Button>
                          </Box>
                      </Box>
                    </>}
                </div>)
            }
            )}
          </>
        ),
      }
    ]
  }
  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={rightSideBarOpen}
      ModalProps={{
        keepMounted: false,
        className: classes.modal,
        BackdropProps: {
          className: classes.backdrop
        },
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        //onBackdropClick: handleClose
      }}
      classes={{
        paper: classes.transactionDetailsDrawer
      }}
    >
      <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} siderBarType={'truckBook'} onClose={handleClose}>
        <div className={classes.titleDiv}>
          <div className={classes.divTitle}>
            {(selectedShop || fromSingleShop) ? "Pay Online" : 'Select a Shop'}
          </div>
          {/* <div className={classes.divSecTitle}>
                  {sideBarSecondaryTitle ? sideBarSecondaryTitle : 'Title'}
            </div> */}
        </div>
      </SideBarDialogTitle >
      <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >
        {shopLedgerData && shopLedgerData.length == 0 && <div className={classes.emptyStateDiv}>
          <img src={`${process.env.PUBLIC_URL}/assets/images/shop-list-empty-state.svg`} alt="Empty State Image" />
          <Typography className={classes.emptyTxt}>Add Shops to Send Money Online</Typography>
        </div>}
        {!selectedShop && shopLedgerData && shopLedgerData.length > 0 && !fromSingleShop && <div >
          <div className={classes.search}>
            {!shopSearchTxt && <div className={classes.searchIcon}>
              <SearchIcon className={classes.sicon} />
            </div>}
            {shopSearchTxt && <div className={classes.closeIcon} onClick={(e) => { setShopSearchTxt("") }}>
              <CloseIcon className={classes.sicon} />
            </div>}
            <InputBase
              placeholder="Search for Shop"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              onChange={(e) => { setShopSearchTxt(e.target.value) }}
              inputProps={{ 'aria-label': 'search' }}
            />
          </div>
          <div className={classes.listingDiv}>
            {/* <div className={classes.subTitleSec} >
                  <Typography className={classes.subTitleTxt}>Driver Name</Typography>
                  <Typography className={classes.subTitleTxt}>Balance</Typography>
              </div> */}
            {shopLedgerData && shopLedgerData.length > 0 && shopLedgerData.filter(shop => {
              return shop && shop.name.toLowerCase().indexOf(shopSearchTxt.toLowerCase()) >= 0;
            }).map((shop) => {
              return (
                <div className={classes.driverDiv} onClick={(e) => { handleShopSelect(shop) }}>
                  <div className={classes.nameDiv}>
                    <Typography className={classes.listDriverName}>
                      <Highlighter
                        highlightClassName={classes.highlight}
                        searchWords={[shopSearchTxt]}
                        autoEscape={true}
                        textToHighlight={shop && shop.name ? shop.name : ""}
                      />
                    </Typography>
                    <Typography className={shop.balance > 0 ? classes.listDriverBalancePositive : shop.balance == 0 ? classes.listDriverBalanceZero : classes.listDriverBalanceNegative}><span className={classes.driverName}>{shop && (shop.balance || shop.balance == 0) ? numberFormat(Math.abs(shop.balance)) : ""}</span><span className={classes.balance}>{shop.balance > 0 ? "ADVANCE" : shop.balance == 0 ? "" : "DUE"}</span></Typography>
                  </div>
                  <div className={classes.balanceDiv} >
                    <Typography className={classes.pay}>Pay</Typography>
                    <RightArrow className={classes.listRightIcon} />
                  </div>
                </div>)
            })}
          </div>
        </div>}
        {selectedShop && <div>
          <div className={classes.driverDetailsDiv}>
            <div className={classes.subTitleSec} >
              <Typography className={classes.subTitleTxt}>Driver Name</Typography>
              <Typography className={classes.subTitleTxt}>{selectedShop && selectedShop.balance > 0 ? "Advance" : selectedShop.balance == 0 ? "Balance" : "Due"}</Typography>
            </div>
            <div className={classes.infoDiv}>
              <div className={classes.nameDiv}>
                <Typography className={classes.listDriverName}>
                  {selectedShop && selectedShop.name ? selectedShop.name : ""}
                </Typography>
              </div>
              <div className={classes.balanceDiv} >
                <Typography className={selectedShop && selectedShop.balance > 0 ? classes.listDriverBalancePositive : classes.listDriverBalanceNegative}>{selectedShop && (selectedShop.balance || selectedShop.balance == 0) ? numberFormat(Math.abs(selectedShop.balance)) : ""}</Typography>
              </div>
            </div>
          </div>
          <Form
            onSubmit={onSubmit}
            //keepDirtyOnReinitialize
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit; formValues = values; return (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid container alignItems="flex-start" spacing={3}>
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx} className={classes.ptV1}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </form>
              )
            }}
          />
        </div>}
      </SideBarDialogContent>
      <SideBarDialogActions className={classes.sideBarActions} >
        {shopLedgerData && shopLedgerData.length == 0 &&
          <>
            <Button variant="contained" className={classes.addCta} onClick={handleAddShopClick} >
              Add Shop
            </Button>
          </>}
        {!selectedShop && shopLedgerData && shopLedgerData.length > 0 && <>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
            Close
          </Button>
        </>}
        {selectedShop &&
          <div className={classes.divActionsPayment}>
            {!fromSingleShop &&
              <Button variant="contained" className='modal-close-cta' onClick={() => { setSelectedShop(null); setShopSearchTxt("") }} >
                Back
              </Button>
            }
            {fromSingleShop &&
              <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
                Close
              </Button>
            }
            <Button disabled={Object.keys(validate(initialValues)).length != 0 || !bankList || bankList.filter(v => v && v.is_default && v.broker_verification_status).length < 1} variant="contained" className={classes.payNowButton} onClick={event => submit(event)} >
              Pay Now
            </Button>
          </div>
        }
      </SideBarDialogActions>
      {addBankDetails && <AddBankDetailsDialog type={"KHATA_SHOP"} selectedData={selectedShop} open={addBankDetails} onClose={handleAddBankClose} onSave={handleAddBankSave} />}
      {selectBank && <BankDetailsSelectionDialog type={"KHATA_SHOP"} selectedData={selectedShop} open={selectBank} onClose={handleSelectBankClose} onSave={handleSelectBankSave} />}
      {successCreation && <SuccessDialog open={successCreation} title={"Account Verified Successfully"} onClose={handleSuccessClose} />}
      {failureCreation && <FailureDialog open={failureCreation} title={"Account Verification Failed"} subTitle={"Please Re-Check the Bank Account details"} onClose={handleFailureClose} />}
      {addPhoneNumber && <AddPhoneNumberDialog open={addPhoneNumber} type={"shop"} onClose={addPhoneNumberDialogClose} onConfirm={addPhoneNumberDialogConfirm} entityData={selectedShop} calledFromFlow={"onlinePaymentShop"} />}
      {addShopOpen && <AddShop open={addShopOpen} onClose={handleAddShopModalClose} onSave={handleShopSave} />}
      {customPGOpen && <DwebPaymentGateWayDialog open={customPGOpen} orderRequestData={orderRequestData} cashFreeOrderData={cashFreeOrderData} onClose={handleCustomPGClose} onSave={handleCustomPGConfirm} />}
    </Drawer >
  );
};

PayShopSideBar.propTypes = {
  rightSideBarOpen: PropTypes.bool,
  toggleRightSideBar: PropTypes.func
};
const PayShopSideBarWithRouter = withRouter(PayShopSideBar);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchChatView: (value) => dispatch(updateChatView(value)),
  dispatchToggleChatSupport: (value) => dispatch(toggleChatSupport(value)),
  dispatchBiltyContinueClick: (value) => dispatch(biltyContinueClick(value)),
  dispatchFetchAllDrivers: (data, onSuccess, onFailure) => (dispatch(getDriverLedgerV2(data, onSuccess, onFailure))),
  dispatchGetShopsDataAction: (requestData, onSuccess, onFailure) =>
    dispatch(
      getShopKhataData(
        requestData,
        () => {
          logger.log("Trip Ledger", "Trip Ledger Data Loading Success");
          if (onSuccess) {
            onSuccess(requestData);
          }
        },
        () => {
          logger.log("Trip Ledger", "Trip Ledger Data Loading Failure");
        }
      )
    ),
  dispatchFetchBankDetails: (data, onSuccess, onFailure) => (dispatch(getBankDetails(data, onSuccess, onFailure))),
  dispatchGetPaymentLink: (data, onSuccess, onFailure) => (dispatch(getPaymentLink(data, onSuccess, onFailure))),
  dispatchGetPaymentInitiate: (data, onSuccess, onFailure) => (dispatch(getPaymentInitiate(data, onSuccess, onFailure))),
  dispatchGetOnlinePaymentsConfig: (onSuccess, onFailure) => { dispatch(onlinePaymentsConfig(onSuccess, onFailure)) },
  dispatchGetUserDetails: (onSuccess, onFailure) => { dispatch(getUserDetails(onSuccess, onFailure)) }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayShopSideBarWithRouter);
